export enum ValidateStatus {
    none = "",
    success = "success",
    warning = "warning",
    error = "error",
    validating = "validating",
}
